import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import LoginPage from './screens/login/LoginPage';
import NotFound from './components/NotFound';
import PrivateRoute from './components/PrivateRoute';
import ListAccountPage from './screens/mana-account/ListAccountPage';
import ListBranchesPage from './screens/branches/ListBranchesPage';
import ManagerRegisterServicesPage from './screens/register-services/ManagerRegisterServicesPage';
import { useSelector } from 'react-redux';
import ChangePassPage from './screens/changepass/ChangePassPage';
import DashboardPage from './screens/dashboard/DashboardPage';
import ListCustomerPage from './screens/mana-customer/ListCustomerPage';
import ListEmployeePage from './screens/employees/ListEmployeePage';
import ListPositionsPage from './screens/positions/ListPositionsPage';
import ListServicesPage from './screens/mana-services/ListServicesPage';
import ListProductsPage from './screens/products/ListProductsPage';
import ListCommissionServicePage from './screens/service-position/ListCommissionServicePage';
import ListOpeningBalancePage from './screens/opening-balance/ListOpeningBalancePage';
import ListWarehousePage from './screens/warehouses/ListWarehousePage';
import ListImportOrderPage from './screens/import-orders/ListImportOrderPage';
import ListExportOrderPage from './screens/export-orders/ListExportOrderPage';
import InventoryReportPage from './screens/inventory/InventoryReportPage';
import InventoryXNTReportPage from './screens/inventory-xnt/InventoryXNTReportPage';
import ServiceCommissionReportPage from './screens/report/ServiceCommissionReportPage';
import ConsultantCommissionReportPage from './screens/report/ConsultantCommissionReportPage';
import ConsultantServiceDetailReportPage from './screens/report/ConsultantServiceDetailReportPage';
import ConsultantOrderDetailReportPage from './screens/report/ConsultantOrderDetailReportPage';
import ListCustomerSupportPage from './screens/customer-support/ListCustomerSupportPage';
import ListLogsSupportPage from './screens/customer-support-logs/ListLogsSupportPage';
import ImportCustomerPage from './screens/mana-customer/ImportCustomerPage';
import ImportProductPage from './screens/products/ImportProductPage';
import ImportServicePage from './screens/mana-services/ImportServicePage';
import ListCustomerLogsPage from './screens/customer-logs/ListCustomerLogsPage';
import ListCustomerDebtPage from './screens/customer-debt/ListCustomerDebtPage';
import ListSalaryPage from './screens/salaries/ListSalaryPage';

const AppRouter = () => {
    const userReducer = useSelector(state => state?.userReducer?.data);
    return (
        <BrowserRouter>
            <Routes>
                <Route path='*' element={<NotFound />} />
                <Route path="/dang-nhap" element={
                    <LoginPage />
                } />
                <Route path="/" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ManagerRegisterServicesPage />
                    </PrivateRoute>
                } />
                <Route path="/dang-ky-dich-vu" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ManagerRegisterServicesPage />
                    </PrivateRoute>
                } />
                <Route path="/dashboard" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <DashboardPage />
                    </PrivateRoute>
                } />
                <Route path="/account" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <ListAccountPage />
                    </PrivateRoute>
                } />
                <Route path="/chi-nhanh" element={
                    <PrivateRoute requiredRoles={[1]}>
                        <ListBranchesPage />
                    </PrivateRoute>
                } />

                <Route path="/doi-mat-khau" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ChangePassPage />
                    </PrivateRoute>
                } />

                <Route path="/thong-tin-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerPage />
                    </PrivateRoute>
                } />
                <Route path="/employees" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListEmployeePage />
                    </PrivateRoute>
                } />
                <Route path="/danh-muc-chuc-vu" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListPositionsPage />
                    </PrivateRoute>
                } />

                <Route path="/danh-muc-dich-vu" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListServicesPage />
                    </PrivateRoute>
                } />
                <Route path="/danh-muc-san-pham" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListProductsPage />
                    </PrivateRoute>
                } />
                <Route path="/cong-tua" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListCommissionServicePage />
                    </PrivateRoute>
                } />
                <Route path="/nhap-du-dau-ky" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListOpeningBalancePage />
                    </PrivateRoute>
                } />
                <Route path="/danh-sach-kho" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListWarehousePage />
                    </PrivateRoute>
                } />
                <Route path="/nhap-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListImportOrderPage />
                    </PrivateRoute>
                } />
                <Route path="/xuat-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListExportOrderPage />
                    </PrivateRoute>
                } />
                <Route path="/bao-cao-ton-kho" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <InventoryReportPage />
                    </PrivateRoute>
                } />
                <Route path="/bao-cao-xntk" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <InventoryXNTReportPage />
                    </PrivateRoute>
                } />
                <Route path="/thong-ke-cong-tua" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ServiceCommissionReportPage />
                    </PrivateRoute>
                } />
                <Route path="/hoa-hong-tu-van-vien" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ConsultantCommissionReportPage />
                    </PrivateRoute>
                } />
                <Route path="/chi-tiet-tu-van-dich-vu" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ConsultantServiceDetailReportPage />
                    </PrivateRoute>
                } />
                <Route path="/chi-tiet-tu-van-san-pham" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ConsultantOrderDetailReportPage />
                    </PrivateRoute>
                } />
                <Route path="/khach-hang-can-cham-soc" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerSupportPage />
                    </PrivateRoute>
                } />
                <Route path="/lich-su-cham-soc" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListLogsSupportPage />
                    </PrivateRoute>
                } />
                <Route path="/import-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ImportCustomerPage />
                    </PrivateRoute>
                } />
                <Route path="/import-danh-muc-san-pham" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ImportProductPage />
                    </PrivateRoute>
                } />
                <Route path="/import-danh-muc-dich-vu" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ImportServicePage />
                    </PrivateRoute>
                } />
                <Route path="/lich-su-su-dung-dich-vu" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerLogsPage />
                    </PrivateRoute>
                } />
                <Route path="/cong-no-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerDebtPage />
                    </PrivateRoute>
                } />
                <Route path="/cong-no-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerDebtPage />
                    </PrivateRoute>
                } />
                <Route path="/cong-no-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerDebtPage />
                    </PrivateRoute>
                } />
                <Route path="/cong-no-khach-hang" element={
                    <PrivateRoute requiredRoles={[1, 2, 3]}>
                        <ListCustomerDebtPage />
                    </PrivateRoute>
                } />
                <Route path="/salary" element={
                    <PrivateRoute requiredRoles={[1, 2]}>
                        <ListSalaryPage />
                    </PrivateRoute>
                } />
            </Routes>

        </BrowserRouter>
    );
};

export default AppRouter;